import { render, staticRenderFns } from "./PathologiesList.vue?vue&type=template&id=7d121970&scoped=true"
import script from "./PathologiesList.vue?vue&type=script&lang=js"
export * from "./PathologiesList.vue?vue&type=script&lang=js"
import style0 from "./PathologiesList.vue?vue&type=style&index=0&id=7d121970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d121970",
  null
  
)

export default component.exports